import { render, staticRenderFns } from "./Ingredient.vue?vue&type=template&id=bba642a2&scoped=true&"
import script from "./Ingredient.vue?vue&type=script&lang=js&"
export * from "./Ingredient.vue?vue&type=script&lang=js&"
import style0 from "./Ingredient.vue?vue&type=style&index=0&id=bba642a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba642a2",
  null
  
)

export default component.exports